import React, { useState } from 'react';
import ReactModal from 'react-modal';
import clsx from 'clsx';
import ContentDivider from '~/components/shared/dividers/ContentDivider';
import VideoModal from '~/components/shared/video/VideoModal';
import { getSectionClassNames } from '~/utilities/component-color';
import DetailedContentItem from './DetailedContentItem';

const DetailedContentComponent = ({
  detailedContentItems,
  hasContentDivider,
  componentBackgroundColor
}) => {
  const [selectedContentGuid, selectContent] = useState(null);
  const selectedContent =
    detailedContentItems && detailedContentItems.find((item) => item.guid === selectedContentGuid);
  const hasAnimatedContent = detailedContentItems.some((item) => item.isAnimated);
  const backgroundColor = hasAnimatedContent ? 'white' : componentBackgroundColor;

  const setSelectedContent = (guid) => {
    if (guid === selectedContentGuid) {
      selectContent(null);
    } else {
      selectContent(guid);
    }
  };

  ReactModal.setAppElement('#wrapper');

  return (
    <section className={getSectionClassNames(backgroundColor)}>
      <div className={clsx(!hasAnimatedContent && 'container-fluid')}>
        {detailedContentItems.map((item) => (
          <DetailedContentItem
            key={item.guid}
            {...item}
            addContainer={hasAnimatedContent}
            setSelectedContent={setSelectedContent}
          />
        ))}

        <VideoModal
          {...selectedContent}
          selectFunction={setSelectedContent}
          isActive={!!selectedContentGuid}
        />
        {hasContentDivider && <ContentDivider />}
      </div>
    </section>
  );
};

export default DetailedContentComponent;
